import { config } from '@services/config';
import { IndicationGetResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { indicationQueryKey } from './keys';

export const useIndication = (indicationId: string) => {
  const client = useClient();

  return useQuery<IndicationGetResponse, Error>({
    queryKey: indicationQueryKey.getWithParams({ indicationId }),
    queryFn: () => client.get(`indication/${indicationId}`).json<IndicationGetResponse>(),
    refetchOnWindowFocus: false,
    ...config,
  });
};
